import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    document.title = "Journal — MAISON FAUBOURG";
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="blog-list" className="pt-32 pb-20 bg-bone">
      <section className="container-max">
        <p className="overline">— Journal d'atelier</p>
        <h1 className="font-display font-light text-6xl md:text-8xl lg:text-9xl leading-[0.9] tracking-tighter mt-6">
          Lire,<br />
          comprendre,<br />
          <em className="italic text-terracotta">rénover</em>.
        </h1>
        <p className="mt-8 max-w-xl text-ink/70 text-lg">
          Conseils, méthodes, références. Tout ce que nous savons sur la rénovation d'appartement à Paris, librement partagé.
        </p>
      </section>

      <section className="container-max mt-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
          {posts.map((p, i) => (
            <motion.article
              key={p.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.1 }}
              className="group"
            >
              <Link to={`/journal/${p.slug}`} data-testid={`blog-link-${p.slug}`}>
                <div className="aspect-[5/4] overflow-hidden bg-ivory">
                  <img src={p.cover} alt={p.title} className="w-full h-full object-cover img-zoom" loading="lazy" />
                </div>
                <div className="mt-6 flex items-center gap-3 overline text-ink/50">
                  <span>{p.category}</span>
                  <span className="w-1 h-1 bg-ink/30" />
                  <span>{new Date(p.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}</span>
                  <span className="w-1 h-1 bg-ink/30" />
                  <span>{p.read_time}</span>
                </div>
                <h2 className="font-display text-3xl md:text-4xl mt-3 leading-tight">{p.title}</h2>
                <p className="mt-3 text-ink/70 leading-relaxed">{p.excerpt}</p>
                <span className="inline-flex items-center gap-2 mt-5 overline link-arc">
                  Lire <ArrowUpRight className="w-3 h-3" />
                </span>
              </Link>
            </motion.article>
          ))}
        </div>
      </section>
    </div>
  );
}
